export var EVkExternalApiGetStatus;
(function (EVkExternalApiGetStatus) {
    /**
     *     0 - пользователь не авторизован;
     */
    EVkExternalApiGetStatus[EVkExternalApiGetStatus["NotAuthorized"] = 0] = "NotAuthorized";
    /**
     *     1 - пользователь авторизован, не зарегистрирован;
     */
    EVkExternalApiGetStatus[EVkExternalApiGetStatus["AuthorizedNotRegistered"] = 1] = "AuthorizedNotRegistered";
    /**
     *     2 - пользователь авторизован, зарегистрирован;
     */
    EVkExternalApiGetStatus[EVkExternalApiGetStatus["AuthorizedAndRegistered"] = 2] = "AuthorizedAndRegistered";
    /**
     *     3  - пользователь авторизован, зарегистрирован, и совершил покупку игры (для премиум игр).
     */
    EVkExternalApiGetStatus[EVkExternalApiGetStatus["AuthorizedAndRegisteredAndPayed"] = 3] = "AuthorizedAndRegisteredAndPayed";
})(EVkExternalApiGetStatus || (EVkExternalApiGetStatus = {}));
export const VkLoginStatusUserNotAuthorized = 0;
export const VkLoginStatusUserAuthorizedNotRegistered = 1;
export const VkLoginStatusUserAuthorizedAndRegistered = 2;
export const VkLoginStatusUserAuthorizedAndRegisteredAndPayed = 3;
